import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { InputContext } from '../../contexts/InputContext';
import MessageModal from '../../container/MessageModal';
import TextControl from '../../container/customizedInputs/TextControl';
import condicionesServices from '../../services/condicionesServices';
import { errorClassification } from '../../errorHandler';

const CondicionForm = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [condicion, setCondicion] = useState({});
  const [esNuevo, setEsNuevo] = useState(true);
  const [renderHTML, setRenderHTML] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  let { id } = useParams();

  useEffect(() => {
    setEsNuevo( id === undefined )

    if(id){
      fetchCondicion(id)
    } else {
      nuevaCondicion()
    }

  }, [id]);

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Admin')){
      setRenderHTML(true)
    } else if( (authInformation.autenticado === true) && (authInformation.rol !== 'Admin')){
      navigate(`/`);
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  const fetchCondicion = async (id) => {
    try {
      const data = await condicionesServices.obtenerCondicionPorId(id);
      setCondicion(data);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const nuevaCondicion = async () => {
    try {
      setCondicion({nombre: ''});
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const guardarCondicion = async () => {
    try {
      if(esNuevo){
        await condicionesServices.crearCondicion({condicion: condicion});
      } else {
        await condicionesServices.actualizarCondicion(condicion.id, {condicion: condicion});
      }

      alert("Datos actualizados")
      navigate(`/listaCondiciones/`);

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setCondicion({...condicion,
        [name]: value
    })
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()

    guardarCondicion()
  }

  return (
    <>
      {
        renderHTML && (
          <main className="w-100 m-auto" style={{maxWidth: '660px'}}>
            <form>
              <TextControl
                className='mb-3'
                value={condicion.nombre}
                name={'nombre'}
                handleInput={handleInput}
              />

              <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                <button className="btn btn-primary w-100 py-2" onClick={handleFormSubmit} type="submit">Guardar</button>
                <button className="btn btn-outline-secondary px-4" type='button' onClick={() => navigate(-1)}>Volver</button>
              </div>
            </form>
          </main>
        )
      }

     <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
    </>
  );
};

export default CondicionForm;